import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { TranslateModule } from '@ngx-translate/core'

import { AppointmentPortalMenuComponent } from './appointment-portal-menu.component'

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatMenuModule,
    MatButtonModule,
    TranslateModule,
  ],
  exports: [
    AppointmentPortalMenuComponent,
  ],
  declarations: [
    AppointmentPortalMenuComponent,
  ],
  providers: [],
})
export class AppointmentPortalMenuModule { }
